import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';
import { InvestisseurFicheObjectif } from '@lib/models/generated/graphql';
import { FormConfigService } from 'src/app/services/form-config.service';
import { FieldFormControl } from 'src/fieldFormControl/FieldFormControl';
import { NoValidatorError } from 'src/fieldFormControl/validators/ValidatorErrors';

export enum ObjectifsValidatorKey {
  obligatoire = 'objectifObligatoire',
  interdit = 'objectifInterdit',
  auMoinsUn = 'objectifAuMoinsUn',
}

const dataKey = 'objectifs';

export class ObjectifsValidatorsFactory {
  static getValidator(validatorKey: string, config: FormConfigService): ValidatorFn {
    switch (validatorKey) {
      case ObjectifsValidatorKey.obligatoire:
        return objectifObligatoire(config);
      case ObjectifsValidatorKey.interdit:
        return objectifInterdit(config);
      default:
        throw new NoValidatorError(dataKey, validatorKey);
    }
  }
}

export function objectifObligatoire(config: FormConfigService): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const validatorConfig = config.currentFormConfigSubject.value?.fieldConfigs
      ?.find(config => config.fieldKey === dataKey)
      ?.validators?.find(validator => validator.validatorKey === ObjectifsValidatorKey.obligatoire);
    if (!validatorConfig) {
      return null;
    }
    const objectifCodes = validatorConfig?.parameters
      ?.find(parameter => parameter.key === 'codes')
      ?.value?.toString()
      ?.split(',');

    if (objectifCodes && Array.isArray(objectifCodes) && objectifCodes.length && control instanceof FieldFormControl) {
      const controlObjectifCode = control?.params['objectifCode'];
      if (!control.value && control.fieldDataToFicheDataWrapper && controlObjectifCode) {
        if (objectifCodes.includes(controlObjectifCode)) {
          let objectif: InvestisseurFicheObjectif = control.fieldDataToFicheDataWrapper(control.value);
          if (!objectif) {
            return null;
          }
          if (!objectif.isSelected) {
            return {
              code: ObjectifsValidatorKey.obligatoire,
            };
          }
        }
      }
    }

    return null;
  };
}

export function objectifInterdit(config: FormConfigService): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const validatorConfig = config.currentFormConfigSubject.value?.fieldConfigs
      ?.find(config => config.fieldKey === dataKey)
      ?.validators?.find(validator => validator.validatorKey === ObjectifsValidatorKey.interdit);
    if (!validatorConfig) {
      return null;
    }
    const objectifCodes = validatorConfig?.parameters
      ?.find(parameter => parameter.key === 'codes')
      ?.value?.toString()
      ?.split(',')
      .map(code => code.trim());

    if (objectifCodes && Array.isArray(objectifCodes) && objectifCodes.length && control instanceof FieldFormControl) {
      const controlObjectifCode = control?.params['objectifCode'];
      if (control.value !== undefined && control.fieldDataToFicheDataWrapper && controlObjectifCode) {
        if (objectifCodes.includes(controlObjectifCode)) {
          let objectif: InvestisseurFicheObjectif = control.fieldDataToFicheDataWrapper(control.value);
          if (objectif?.isSelected) {
            return {
              custom: 'true',
              code: ObjectifsValidatorKey.interdit,
            };
          }
        }
      }
    }

    return null;
  };
}
